import dashboardNew from "./new";

const home = {
  dashboardNew,
};

export default home;
